<template>
    <fullscreen class="layout-full-page" ref="fullscreen" @change="fullscreenChange">
        <menu-nav />
        <section id="content">
<!--            <keep-alive>-->
                <router-view :key="$route.path"/>
<!--            </keep-alive>-->
        </section>
<!--        <Onglets_Overview />-->
        <Login v-if="!$store.getters.isAuthenticated"/>
    </fullscreen>
</template>

<script>
import Login from "@/views/pages/Login";
import Tooltip from "@/modules/tooltip";
import events from "@/events/events";
import Onglets_Overview from "@/modules/onglet/Onglets_Overview";
import MenuNav from "@/views/menu/Menu_Nav";

export default {
    name: "Template",
    components: {MenuNav, Onglets_Overview, Tooltip, Login},
    data(){
        return{
            fs : false
        }
    },
    methods:{
        fullscreen(){
            this.$refs["fullscreen"].toggle();
        },
        fullscreenChange(value){
            this.fs = value;
        },
        logout(){
            this.$store.dispatch("AUTH_LOGOUT")
        },
        closeAllTabs(){
            events.$emit("onglet:close:all")
        },
        app(){
            this.$vs.dialog({
                color: 'primary',
                title: this.$t('Information'),
                text: this.$t("It is not possible to list the Apps for the moment"),
                acceptText: this.$t('Ok')
            })
        }
    },
    computed:{
        isLogged(){
            return this.$store.getters.isAuthenticated;
        }
    },
}
</script>
